import produce from 'immer';
import {
  DELETE_NOTIFICATIONS_ACTIONTYPE,
  GET_ALL_NOTIFICATIONS_ACTIONTYPE,
  MARK_NOTIFICATIONS_ACK_ACTIONTYPE,
  NOTIF_SELECTED_ACTIONTYPE,
  NOTIF_SELECTED_DEVICE_ACTIONTYPE,
} from './actionTypes';
import { RESET_APP_DATA_ACTIONTYPE } from '../../appContainer/actionTypes';
import { sortByDate } from '../../utils/DateUtils';

export const initialState = {
  all: [],
  queryTime: 0,
  selectedDeviceIMEI: '',
  selectedNotifId: ''
};

/* eslint-disable default-case, no-param-reassign */
const notificationsReducer = produce((draft, action) => {
  const updateNotifs = notifications => {
    const newNotifications = Array.isArray(notifications) ? notifications : [];
    const existingNotifs = draft.all;

    if (!newNotifications.length) {
      return;
    }

    const notifHelper = {};
    const fillHelper = array => {
      array.forEach(notif => {
        notifHelper[notif.uuid] = notif;
      });
    };

    fillHelper(existingNotifs);
    fillHelper(newNotifications);

    let uniqueNotifs = Object.values(notifHelper);
    uniqueNotifs = uniqueNotifs.filter(obj => !obj.deleted)
    sortByDate(uniqueNotifs, 'createdAt');
    draft.all = uniqueNotifs;
  };
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS_ACTIONTYPE.SUCCESS: {
      const { time, notifications } = action.payload;
      updateNotifs(notifications);
      draft.queryTime = time;
      break;
    }
    case DELETE_NOTIFICATIONS_ACTIONTYPE.SUCCESS:
    case MARK_NOTIFICATIONS_ACK_ACTIONTYPE.SUCCESS: {
      const notifications = action.payload;
      updateNotifs(notifications);
      break;
    }
    case NOTIF_SELECTED_DEVICE_ACTIONTYPE.COMPLETED: {
      draft.selectedDeviceIMEI = action.payload;
      break;
    }
    case NOTIF_SELECTED_ACTIONTYPE.COMPLETED: {
      draft.selectedNotifId = action.payload;
      break;
    }
    case RESET_APP_DATA_ACTIONTYPE.TRIGGER:
      return initialState;
  }
}, initialState);

export default notificationsReducer;
